import { Box, type ChakraProps } from '@chakra-ui/react';
import { useCardSupportedTokens } from '@ui/views/card-cronos/core/configs';
import Fuse from 'fuse.js/basic';
import { useMemo } from 'react';

import { useTokenSelectModal } from '../useTokenSelectModal';
import { TokenListEmpty } from './TokenListEmpty';
import { TokenListRow } from './TokenListRow';

export const TokenList = (props: ChakraProps) => {
  const search = useTokenSelectModal((s) => s.search);
  // const tokens = useTokenSelectModal((s) => s.tokens);
  const tokens = useCardSupportedTokens();
  const fuse = useMemo(() => {
    return new Fuse(tokens, {
      keys: ['symbol', 'address'],
    });
  }, [tokens]);
  const searchResult = useMemo(
    () =>
      search
        ? fuse
            .search(search)
            .map((v) => v.item)
            .slice(0, 10)
        : tokens,
    [fuse, search, tokens],
  );
  const isShowEmpty = !searchResult.length;
  return (
    <Box {...props}>
      {isShowEmpty && <TokenListEmpty mt="80px" />}
      {!isShowEmpty && (
        <Box minH="200px">
          {searchResult.map((token, i) => {
            return (
              <TokenListRow
                key={token.address}
                token={token}
                showDivider={i !== searchResult.length - 1}
                ignoreNoBalance={!search}
                // balanceVisible={searchResult.length <= 10}
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
};
